import {Model} from '@vuex-orm/core'

export default class RoomltmsHasOperationmodeAt extends Model {
  static entity = 'roomltmsHasOperationmodesAt'

  static fields() {
    return {
      roomltms_id: this.attr(null),
      operationmodes_id: this.attr(null),
      default: this.attr(null),
    }
  }
}
